import React from 'react';
import _ from 'lodash';
// import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Dropdown, Icon } from 'semantic-ui-react';
import PortalComponent from '../common/PortalComponent';
import styles from './FilterButton.module.css';
import { FILTER_OPERATION } from '../../HelperMethods/enums';
// import {getTempFilterFromLocalStorage} from "../../HelperMethods/LocalStorageUtils"

const FilterMenuButton = React.memo(function FilterMenuButton(props) {
  const {
    selectedFilter = { id: null, name: null },
    allTaskFilters,
    handleMenu,
    handleDeleteMenu,
    handleClearFilter,
    handleUpdateMenu,
    filterModal,
    handleToggleSaveFilter,
    PortalComponentProp = true,
    disabled = false,
    fromRecurringTaskView = false,
    handleFilterMyWatchlist,
    watchlistSelected,
  } = props;

  const { id: selectedFilterId } = selectedFilter;
  const updated = _.get(filterModal, 'updated', false);

  if (fromRecurringTaskView) {
    return (
      <>
        <PortalComponent id="filter-button">
          {(selectedFilter.id || watchlistSelected) && <span className={styles.redDot} />}
          <Dropdown
            item
            disabled={disabled}
            icon={
              <button
                className={styles.filterButton}
                type="button"
                style={{ backgroundColor: updated ? '#C8F4F0' : 'transparent' }}
              >
                <Icon name="filter" />
              </button>
            }
            closeOnBlur
            direction="left"
          >
            <Dropdown.Menu style={{ minWidth: '250px', maxWidth: '350px', maxHeight: '700px', overflowX: 'auto' }}>
              <Dropdown.Item onClick={() => handleClearFilter()}>
                <span>Clear Filter</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </PortalComponent>
      </>
    );
  }

  if (PortalComponentProp) {
    return (
      <>
        <PortalComponent id="filter-button">
          {(selectedFilter.id || watchlistSelected) && <span className={styles.redDot} />}
          <Dropdown
            item
            disabled={disabled}
            icon={
              <button
                className={styles.filterButton}
                type="button"
                style={{ backgroundColor: updated ? '#C8F4F0' : 'transparent' }}
              >
                <Icon name="filter" />
              </button>
            }
            closeOnBlur
            direction="left"
          >
            <Dropdown.Menu style={{ minWidth: '250px', maxWidth: '350px', maxHeight: '700px', overflowX: 'auto' }}>
              <Dropdown.Item
                onClick={handleFilterMyWatchlist}
                style={{
                  display: 'flex',
                  backgroundColor: watchlistSelected ? '#C8F4F0' : 'transparent',
                }}
              >
                <span>My Watchlist</span>
              </Dropdown.Item>
              {(allTaskFilters || []).map(({ name, id, filter }) => (
                <Dropdown.Item
                  onClick={() => {
                    handleMenu({ filter, id, name });
                  }}
                  key={id}
                  style={{
                    display: 'flex',
                    backgroundColor: selectedFilterId === id ? '#C8F4F0' : 'transparent',
                  }}
                >
                  <div style={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {name}
                  </div>
                  <div onClick={(e) => handleDeleteMenu(e, id)} style={{ float: 'right', marginLeft: '10px' }}>
                    <Icon name="trash alternate outline" />
                  </div>
                  <div onClick={(e) => handleUpdateMenu(e, id)} style={{ float: 'right', marginLeft: '10px' }}>
                    <Icon name="edit outline" />
                  </div>
                </Dropdown.Item>
              ))}
              <Dropdown.Item onClick={() => handleClearFilter()}>
                <span>Clear Filter</span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  if (Object.values(filterModal.filterModel).length !== 0 && updated && !selectedFilterId)
                    handleToggleSaveFilter(FILTER_OPERATION.SAVE, filterModal);
                }}
                style={{
                  backgroundColor:
                    filterModal &&
                    filterModal.filterModel &&
                    Object.values(filterModal.filterModel).length !== 0 &&
                    updated &&
                    !selectedFilterId
                      ? '#C8F4F0'
                      : 'transparent',
                }}
              >
                <span>Save Filter</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </PortalComponent>
      </>
    );
  }
  return (
    <div
      style={{
        marginLeft: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {selectedFilter.id && <span className={styles.redDot} style={{ top: '6px', left: '0.5px' }} />}
      <Dropdown
        item
        icon={
          <button
            className={styles.filterButton}
            type="button"
            style={{ backgroundColor: updated ? '#C8F4F0' : 'transparent' }}
          >
            <Icon name="filter" />
          </button>
        }
        disabled={disabled}
        closeOnBlur
        direction="left"
      >
        <Dropdown.Menu style={{ minWidth: '250px', maxWidth: '350px', maxHeight: '700px', overflowX: 'auto' }}>
          {(allTaskFilters || []).map(({ name, id, filter }) => (
            <Dropdown.Item
              onClick={() => {
                handleMenu({ filter, id, name });
              }}
              key={id}
              style={{
                display: 'flex',
                backgroundColor: selectedFilterId === id ? '#C8F4F0' : 'transparent',
              }}
            >
              <div style={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {name}
              </div>
            </Dropdown.Item>
          ))}
          <Dropdown.Item onClick={() => handleClearFilter()}>
            <span>Clear Filter</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
});

FilterMenuButton.propTypes = {
  handleClearFilter: PropTypes.func.isRequired,
  handleMenu: PropTypes.func.isRequired,
  handleDeleteMenu: PropTypes.func.isRequired,
  handleUpdateMenu: PropTypes.func.isRequired,
  disabled: PropTypes.any,
  selectedFilter: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  allTaskFilters: PropTypes.array,
  filterModal: PropTypes.shape({
    filterModel: PropTypes.object,
    updated: PropTypes.bool,
    open: PropTypes.bool,
  }).isRequired,
  handleToggleSaveFilter: PropTypes.func.isRequired,
  PortalComponentProp: PropTypes.any,
  fromRecurringTaskView: PropTypes.any,
  handleFilterMyWatchlist: PropTypes.func.isRequired,
  watchlistSelected: PropTypes.bool.isRequired,
};

export default FilterMenuButton;
